import React, { useState } from 'react';

import InternalDocs from '../Department/Documents/internal-docs';

import { StyledBoxInside, StyledTitleWidget, StyledTitle } from './style';

import { DirectorioBlanco } from '../../../../assets/images';
import { parseQuery } from '../../../utils/urlParser';
import CopiedUrl from '../CopiedUrl';

const MenuDocs = props => {
  const { folderId, associationId } = parseQuery(props.location.search);
  const { department } = props.match.params;
  const [copiedUrl, setCopiedUrl] = useState(undefined);
  const setUrlFolder = newUrl => {
    setCopiedUrl(newUrl);
  };
  return (
    <StyledBoxInside>
      <StyledTitle>
        <StyledTitleWidget
          title={department.toUpperCase().replaceAll('-', ' ')}
          type="ranking"
          icon={DirectorioBlanco}
          small
        />
        <CopiedUrl textUrl={copiedUrl} />
      </StyledTitle>

      <InternalDocs
        rootFolderId={folderId}
        associationId={associationId}
        bcreadcrumbTitle={`${department
          .replaceAll('-', ' ')[0]
          .toUpperCase()}${department
          .replaceAll('-', ' ')
          .slice(1, department.length)
          .toLowerCase()}`}
        history={props.history}
        setUrl={setUrlFolder}
      />
    </StyledBoxInside>
  );
};

export default MenuDocs;
